import { render, staticRenderFns } from "./PointCouponItem.vue?vue&type=template&id=79e49934&scoped=true&"
import script from "./PointCouponItem.vue?vue&type=script&lang=js&"
export * from "./PointCouponItem.vue?vue&type=script&lang=js&"
import style0 from "./PointCouponItem.vue?vue&type=style&index=0&id=79e49934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e49934",
  null
  
)

export default component.exports